import { EPaymentType } from "@/enums"
import { IBalancePost, ICardInfo, ICardPost, IPagarmeCardForm, IPaymentMethod } from "@/interfaces"
import { CardArrayMapper, CardMapper, AddBalanceResponseMapper, PaymentTransactionResponseMapper } from "@/mappers/PaymentMappers"
import Endpoints from "@/network/Endpoints"
import Network from "@/network/Network"
import { keepOnlyNumbers } from "@/utils"

export default class PaymentService {
    static BALANCE_MIN_VALUE = 30
    static listCards = async () => {
        const res = await Network.get<any>(`${Endpoints.cards}`)
        return CardArrayMapper(res)
    }
    static removeCard = async (id: string) => {
        return Network.delete<any>(`${Endpoints.cards}/${id}`)
    }
    static createCard = async (card: ICardPost) => {
        card.document_number = keepOnlyNumbers(card.document_number)
        card.address.zip_code = keepOnlyNumbers(card.address.zip_code)
        const res = await Network.post<any>(`${Endpoints.cards}`, card)
        return CardMapper(res)

    }
    static addBalance = async (params: IBalancePost) => {
        params.document_number = keepOnlyNumbers(params.document_number)
        const res = await Network.post<any>(`${Endpoints.add_balance}`, params)
        return AddBalanceResponseMapper(res)
    }
    static getPaymentTransaction = async (transactionId: string) => {
        const res = await Network.get<any>(`${Endpoints.payment_transactions}/${transactionId}`)
        return PaymentTransactionResponseMapper(res)
    }
    static createCardToken = async (params: IPagarmeCardForm) => {
        params.number = keepOnlyNumbers(params.number)
        const options = {
            method: 'POST',
            headers: { accept: 'application/json', 'content-type': 'application/json' },
            body: JSON.stringify({
                card: params,
                type: 'card'
            })
        };

        return fetch(`https://api.pagar.me/core/v5/tokens?appId=${process.env.VUE_APP_PAGARME_PUBLIC_KEY}`, options)
            .then(response => response.json())
            .catch(err => {
                console.log(err)
                throw (err)
            })
    }
    static getDefaultPayment(lastCard: ICardInfo | null, balance: number): IPaymentMethod | null {
        if (lastCard == null && balance <= 0) {
            return null
        }
        if (lastCard) {
            if (balance < 30) {
                return {
                    payment_type: EPaymentType.credit_card,
                    card_info: lastCard
                }
            } else {
                return {
                    payment_type: EPaymentType.balance,
                    card_info: null
                }
            }
        }
        return {
            payment_type: EPaymentType.balance,
            card_info: null
        }
    }
}